module.exports = __webpack_public_path__ + "static/media/hall-CSE.d7633b84.svg";